import React, { useEffect, useState } from 'react';
import { gameUpdateEvents } from './events/game-update-events';

const SoccerBallAnimation = () => (
  <div className="relative w-16 h-16 animate-bounce">
    <svg viewBox="0 0 64 64" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill="#ffffff" stroke="#000000" strokeWidth="2" />
      <path d="M32 2 C42 12, 52 12, 62 32 C52 52, 42 52, 32 62 C22 52, 12 52, 2 32 C12 12, 22 12, 32 2" fill="none" stroke="#000000" strokeWidth="2" />
      <path d="M2 32 H62 M32 2 V62" stroke="#000000" strokeWidth="2" />
      <path d="M17 8 L47 56 M47 8 L17 56" stroke="#000000" strokeWidth="2" />
    </svg>
  </div>
);

// The main service screen component
const GameUpdateScreen: React.FC = () => {
  const [isUpdating, setIsUpdating] = useState(gameUpdateEvents.isUpdating);
  const [message, setMessage] = useState(gameUpdateEvents.message);
  
  useEffect(() => {
    // Initial state
    setIsUpdating(gameUpdateEvents.isUpdating);
    setMessage(gameUpdateEvents.message);
    
    // Subscribe to game update events
    const unsubscribe = gameUpdateEvents.addListener(() => {
      setIsUpdating(gameUpdateEvents.isUpdating);
      setMessage(gameUpdateEvents.message);
    });
    
    return unsubscribe;
  }, []);

  if (!isUpdating) return null;
  
  return (
    <div className="fixed inset-0 bg-green-950/95 flex flex-col items-center justify-center z-50">
      <div className="bg-white/20 rounded-lg p-8 max-w-md text-center backdrop-blur-sm">
        <h2 className="text-2xl font-bold text-white mb-6">FPL Service Update</h2>
        
        <div className="flex justify-center my-8">
          <SoccerBallAnimation />
        </div>
        
        <p className="text-lg text-white mb-4">{message || 'The Fantasy Premier League is being updated...'}</p>
        
        <div className="flex justify-center space-x-2 my-4">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
        </div>
        
        <p className="text-sm text-white/80 mt-6">
          This usually takes a few minutes. The app will automatically refresh when the service is back online.
        </p>
      </div>
    </div>
  );
};

export default GameUpdateScreen;